module.exports = __webpack_public_path__ + "media/img/landing/banner-4faf64c1bf1efcc940151f8b791dc118.png";